/** @jsx jsx */
import { Flex, jsx, Link } from 'theme-ui'
import { any, arrayOf, shape, string, bool } from 'prop-types'
import ParseLink from '../../common/ParseLink'
import ManageWebsitesFeatureCard from './ManageWebsitesFeatureCard'
import parseLinkTokens from 'utils/parseLinkTokens'
import FeatureCard from './FeatureCard'

const FeatureList = ({ featureCards }) => {
  return (
    <Flex sx={{ display: 'grid' }}>
      <Flex
        sx={{
          maxWidth: [600, 900, 1200],
          display: 'grid',
          gridTemplateColumns: [
            'repeat(1, 1fr)',
            'repeat(2, 1fr)',
            'repeat(3, 1fr)',
            'repeat(4, 1fr)',
          ],
          gridAutoRows: '1fr',
          gridColumnGap: '20px',
          gridRowGap: '20px',
        }}
      >
        {featureCards &&
          featureCards.map(
            ({
              cardIcon,
              description,
              descriptionRichText,
              headline,
              slug,
              id,
              isSocialMediaButton,
              mainSectionButtonText,
              mainSectionButtonLink,
              subSectionButtonLink,
              subSectionButtonText,
              subSectionHeadline,
              isRichTextCard,
            }) => {
              //Render rich text card with a clickable content
              if (isRichTextCard) {
                return (
                  <Link
                    key={id}
                    href={slug?.slug}
                    sx={{
                      color: 'black',
                      textDecoration: 'none',
                      height: '100%',
                      cursor: 'default',
                    }}
                  >
                    <FeatureCard
                      icon={`https:${cardIcon?.file?.url}`}
                      subTitle={description}
                      descriptionRichText={descriptionRichText}
                      title={headline}
                      isFeatureVisible={true}
                      isSocialMediaButton={isSocialMediaButton}
                      subSectionHeadline={subSectionHeadline}
                      subSectionButtonText={subSectionButtonText}
                      subSectionButtonLink={subSectionButtonLink}
                      mainSectionButtonLink={mainSectionButtonLink}
                      mainSectionButtonText={mainSectionButtonText}
                    />
                  </Link>
                )
              }
              return slug?.slug === parseLinkTokens?.EASYSITE ? (
                <ManageWebsitesFeatureCard
                  key={id}
                  icon={`https:${cardIcon?.file?.url}`}
                  description={description}
                  descriptionRichText={descriptionRichText}
                  title={headline}
                  subSectionButtonLink={subSectionButtonLink}
                />
              ) : (
                <ParseLink
                  isFeatureList
                  key={id}
                  id={id}
                  cardIcon={cardIcon}
                  description={description}
                  descriptionRichText={descriptionRichText}
                  isSocialMediaButton={isSocialMediaButton}
                  text={headline}
                  title={slug?.title}
                  slug={slug?.slug}
                  mainSectionButtonLink={mainSectionButtonLink}
                  mainSectionButtonText={mainSectionButtonText}
                  subSectionHeadline={subSectionHeadline}
                  subSectionButtonText={subSectionButtonText}
                  subSectionButtonLink={subSectionButtonLink}
                />
              )
            }
          )}
      </Flex>
    </Flex>
  )
}
FeatureList.propTypes = {
  featureCards: arrayOf(
    shape({
      headline: string,
      id: string,
      slug: any,
      cardIcon: any,
      isSocialMediaButton: bool,
      descriptionRichText: any,
    })
  ),
}
export default FeatureList
